import React, { Component } from 'react';

import { ReactComponent as CloseIcon } from '../../../assets/images/svg/close-btn.svg';

class Modal extends Component {
    render() {
        const { modalVisibility, onModalChange, styles } = this.props;

        return (
            <div className={`${modalVisibility ? 'oi-modal--mod' : ''} oi-modal`}>
                <div className="oi-modal__container">
                    <div className={`${modalVisibility ? 'oi-modal__card--mod' : ''} oi-modal__card ${styles}`}>
                        <CloseIcon
                            className={`${modalVisibility ? 'oi-modal__close-btn--mod' : ''} oi-modal__close-btn`}
                            onClick={onModalChange}
                        />

                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;
